import {Component, OnInit} from '@angular/core';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';
import {CatalogService} from '../catalogue/catalog-api/catalog.service';
import {ToasterService} from 'angular2-toaster';

const DEBOUNCE_TIME = 10;
const ES_RESULTS_SIZE = 20;
const ES_LARGER_SEARCH_AMOUNT = 100;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'justwatch-id-fetch-search-titles',
    templateUrl: 'justwatch-id-fetch-search-titles.component.html',
    styleUrls: ['justwatch-id-fetch-search-titles.component.scss']
})
export class JustwatchIdFetchSearchTitlesComponent implements OnInit {
    // Navigation
    navIndex = 0;
    private shouldDoSearch = false;
    // Subject for search debounce and search value
    private subject = new Subject<string>();
    searchValue = '';

    // Page booleans
    searchLoading = false;

    // ES Results
    results = [];
    private finalsResults = [];

    // Selected show for catalog-manage component
    selectedShow;
    // Number of hits for the ES search and details for loading more
    totalResultsMetadata = 0;
    totalResultsImdb = 0;
    private from = 0;
    private largerSearch = false;
    hasMore = false;

    constructor(private catalogService: CatalogService,
                private toasterService: ToasterService) {
    }

    ngOnInit() {
        this.subject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged((prev, curr) => prev === curr && !this.shouldDoSearch)
            .subscribe(searchValue => {
                // Search value has changed, reset results, total results and from
                this.results = [];
                this.finalsResults = [];
                this.totalResultsImdb = 0;
                this.totalResultsMetadata = 0;
                this.from = 0;
                this.doSearch(searchValue);
            });
    }

    onEnter(searchValue) {
        this.doSearch(searchValue);
    }


    doSearch(searchValue) {

        this.shouldDoSearch = false;
        this.searchLoading = true;
        this.searchValue = searchValue;

        if (this.navIndex === 0) {

            const queryJSON = this.catalogService.createJustwatchQuery(searchValue);

            this.catalogService.callJustwatchEndpoint(
                queryJSON,
                'justwatch_id'
            ).then((res) => {

                if (res.justwatch_id) {
                    this.getByJustwatchId(res.justwatch_id);
                } else {

                    this.searchLoading = false;
                }
            }).catch((err) => {
                console.error('Failed to call the ES proxy in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
                this.searchLoading = false;
            });
        } else {
            this.getByJustwatchId(searchValue);
        }
    }

    private getByJustwatchId(res) {
        const queryJSON = this.catalogService.createJustwatchEsQuery(res);

        this.catalogService.callJustwatchESEndpoint(
            queryJSON,
            'justwatch_title_metadata'
        ).then((res) => {

            this.results = this.results.concat(res.hits.hits.map(this.catalogService.mapJustwatchEsResults));

            this.searchLoading = false;
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
            this.searchLoading = false;
        });
    }

    handleLoadMore() {
        if (this.largerSearch) {
            this.from = this.from + ES_LARGER_SEARCH_AMOUNT;
        } else {
            this.from = this.from + ES_RESULTS_SIZE;
        }
        this.doSearch(this.searchValue);
    }

    handleNavSelect(index) {
        this.navIndex = index;
    }

    handleOpen(result) {
        if (!this.selectedShow || (this.selectedShow && this.selectedShow.id !== result.id)) {
            this.selectedShow = {
                business_question: result.business_question,
                industry_segment: result.industry_segment,
                chart_names: result.chart_names,
                id: result.id,
            };
        } else if (this.selectedShow && this.selectedShow.id === result.id) {
            // Trigger a change for the property
            setTimeout(() => {
                this.selectedShow = {
                    business_question: undefined,
                    industry_segment: undefined,
                    chart_names: undefined,
                    id: undefined

                };
            });
            setTimeout(() => {
                this.selectedShow = {
                    business_question: result.business_question,
                    industry_segment: result.industry_segment,
                    chart_names: result.chart_names,
                    id: result.id,
                };
            });
        }
    }

    onKeyUp(searchValue) {
        this.searchValue = searchValue;
        if (this.shouldSearch()) {
            this.subject.next(searchValue);
        } else {
            this.results = [];
        }
    }

    shouldSearch() {
        return this.searchValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/justwatch-id-fetch/justwatch-id-fetch-search-titles.component.ts